module.exports = __webpack_public_path__ + "img/Graph_icons_Subject.269fd8a6.svg";